import * as React from 'react';

var useLockBodyScroll = function useLockBodyScroll() {
  var originalOverflow = React.useRef(document.body.style.overflow);
  var lockBodyScroll = React.useCallback(function (element) {
    var style = window.document.body.style;
    if (element) {
      // Save the original overflow style
      originalOverflow.current = style.overflow;
      // TODO: ADSDEV-622 Prevent scroll with CSS architecture
      style.overflow = 'hidden';
    } else {
      // Restore the original overflow style
      style.overflow = originalOverflow.current;
    }
  }, []);
  return lockBodyScroll;
};

export { useLockBodyScroll };
//# sourceMappingURL=useLockBodyScroll.js.map
